import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/verval/cv-kasek',
    name: 'verval-cv-kasek',
    component: () => lazyLoadView(import('@views/instansi/verval/cv/Index')),
    meta: {
      title: 'Pemeriksaan CV Kepala Sekolah',
      jenis: 'kasek',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/cv-pa',
    name: 'verval-cv-pa',
    component: () => lazyLoadView(import('@views/instansi/verval/cv/Index')),
    meta: {
      title: 'Pemeriksaan CV Fasilitator',
      jenis: 'instruktur',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/sehat-pa',
    name: 'verval-sehat-pa',
    component: () => lazyLoadView(import('@views/instansi/verval/sehat/Index')),
    meta: {
      title: 'Pemeriksaan Surat Keterangan Sehat',
      jenis: 'instruktur',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/sehat-ks',
    name: 'verval-sehat-ks',
    component: () => lazyLoadView(import('@views/instansi/verval/sehat/Index')),
    meta: {
      title: 'Pemeriksaan Surat Keterangan Sehat',
      jenis: 'kasek',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/mundur-pa',
    name: 'verval-mundur-pa',
    component: () => lazyLoadView(import('@views/instansi/verval/mundur/Index')),
    meta: {
      title: 'Pemeriksaan Surat Pernyataan Komitmen',
      jenis: 'instruktur',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/izin-ks',
    name: 'verval-izin-ks',
    component: () => lazyLoadView(import('@views/instansi/verval/izin/Index')),
    meta: {
      title: 'CV KS Cadangan',
      jenis: 'kasek',
    },
  },
  {
    path: '/i/:id(\\d+)/prasyarat',
    name: 'cek-prasyarat',
    component: () => lazyLoadView(import('@views/instansi/verval/prasyarat/Index')),
    meta: {
      title: 'Pemeriksaan Prasyarat Pendafataran',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/fsp',
    name: 'verval-fsp',
    component: () => lazyLoadView(import('@views/instansi/verval/biodata/Index')),
    meta: {
      title: 'Verval Detail Profil FSP',
    },
  },
  {
    path: '/i/:id(\\d+)/biodata-edit/fsp',
    name: 'verval-biodata-edit-fsp',
    component: () => lazyLoadView(import('@views/instansi/verval/biodata/Edit')),
    meta: {
      title: 'Verval Perubahan Biodata FSP',
    },
  },
  {
    path: '/i/:id(\\d+)/verval/berkas-tambahan-fsp',
    name: 'verval-berkas-tambahan-fsp',
    component: () => lazyLoadView(import('@views/instansi/verval/berkas/Index')),
    meta: {
      title: 'Lihat Berkas Tambahan FSP',
    },
  },
];
